export enum PropertyBookBarSignalNames {
  CHECK_AVAILABILITY_CALL_TO_ACTION_BUTTON_CLICK = "CHECK_AVAILABILITY_CALL_TO_ACTION_BUTTON_CLICK",
}
